var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432.04 355.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fec829;}.cls-2{fill:#244c9b;}.cls-3{fill:#e73b2c;}.cls-4{fill:#6b6c6e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.82,195.52A6.48,6.48,0,0,0,11,199.68a6.54,6.54,0,0,0,4.49-8.05,6.47,6.47,0,0,0-8.18-4.15,6.53,6.53,0,0,0-4.49,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,216.78a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35,6.86,6.86,0,0,0-4.71,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.5,238.34a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35,6.87,6.87,0,0,0-4.71,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.6,258.86a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35,6.86,6.86,0,0,0-4.71,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.16,277a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35A6.86,6.86,0,0,0,35.16,277"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,293.89a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35A6.86,6.86,0,0,0,50,293.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.52,309a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35A6.87,6.87,0,0,0,65.52,309"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.71,321.9a6.78,6.78,0,0,0,8.58,4.36A6.87,6.87,0,0,0,96,317.81a6.78,6.78,0,0,0-8.58-4.35,6.86,6.86,0,0,0-4.71,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.24,332.5a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35,6.87,6.87,0,0,0-4.71,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.84,342.15a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35,6.86,6.86,0,0,0-4.71,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.68,347.85a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35,6.86,6.86,0,0,0-4.71,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.86,350.91a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35,6.86,6.86,0,0,0-4.71,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.41,350.91a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35,6.86,6.86,0,0,0-4.71,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.1,348.66a6.78,6.78,0,0,0,8.58,4.36,6.87,6.87,0,0,0,4.71-8.45,6.78,6.78,0,0,0-8.58-4.35,6.86,6.86,0,0,0-4.71,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.52,342.42a5.35,5.35,0,0,0,6.77,3.44A5.41,5.41,0,0,0,248,339.2a5.35,5.35,0,0,0-6.76-3.43,5.41,5.41,0,0,0-3.72,6.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.85,334.58a4.28,4.28,0,0,0,5.41,2.75,4.33,4.33,0,0,0,3-5.32,4.39,4.39,0,0,0-8.38,2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.33,324.17a3.72,3.72,0,1,0,2.52-4.5,3.63,3.63,0,0,0-2.52,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.85,311.18a3.45,3.45,0,0,0,4.37,2.22,3.5,3.5,0,0,0,2.4-4.3,3.46,3.46,0,0,0-4.37-2.22,3.5,3.5,0,0,0-2.4,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.14,297.42a2.06,2.06,0,0,0,2.6,1.32,2.09,2.09,0,0,0,1.43-2.56,2.06,2.06,0,0,0-2.6-1.32,2.09,2.09,0,0,0-1.43,2.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.26,171.46a6.48,6.48,0,0,0,8.18,4.16,6.54,6.54,0,0,0,4.49-8.05,6.47,6.47,0,0,0-8.18-4.15,6.54,6.54,0,0,0-4.49,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.75,149.21a6.48,6.48,0,0,0,8.18,4.16,6.54,6.54,0,0,0,4.49-8.05,6.47,6.47,0,0,0-8.18-4.15,6.54,6.54,0,0,0-4.49,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.2,125.68a6.48,6.48,0,0,0,8.18,4.16,6.54,6.54,0,0,0,4.49-8,6.47,6.47,0,0,0-8.18-4.15,6.53,6.53,0,0,0-4.49,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.74,82.73a5.53,5.53,0,0,0,7,3.55,5.59,5.59,0,0,0,3.84-6.88,5.52,5.52,0,0,0-7-3.54,5.58,5.58,0,0,0-3.84,6.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.39,62.61a4.93,4.93,0,0,0,6.23,3.17,4.86,4.86,0,1,0-6.23-3.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.64,42.63a4.58,4.58,0,0,0,5.81,2.95,4.65,4.65,0,0,0,3.19-5.72,4.6,4.6,0,0,0-5.81-3,4.66,4.66,0,0,0-3.19,5.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.53,26.76A3.45,3.45,0,0,0,74.9,29a3.5,3.5,0,0,0,2.4-4.3,3.46,3.46,0,0,0-4.37-2.22,3.5,3.5,0,0,0-2.4,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.75,14.89A2.42,2.42,0,1,0,89.39,12a2.39,2.39,0,0,0-1.64,2.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,103.12a5.53,5.53,0,0,0,7,3.55,5.59,5.59,0,0,0,3.84-6.88,5.53,5.53,0,0,0-7-3.55A5.6,5.6,0,0,0,14,103.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.82,68.26A6.19,6.19,0,1,0,60,65.47a6,6,0,0,0-8.13,2.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.68,85.66A6.35,6.35,0,0,0,43.91,94a6.41,6.41,0,0,0,8.54-2.92,6.49,6.49,0,0,0-11.77-5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.79,105.9A6.34,6.34,0,0,0,34,114.28a6.41,6.41,0,0,0,8.54-2.92A6.33,6.33,0,0,0,39.33,103a6.4,6.4,0,0,0-8.54,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.05,127.82a6.34,6.34,0,0,0,3.24,8.38,6.41,6.41,0,0,0,8.54-2.92,6.33,6.33,0,0,0-3.24-8.37,6.4,6.4,0,0,0-8.54,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.35,148a6.49,6.49,0,1,0,8.53-2.91A6.35,6.35,0,0,0,21.35,148"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.81,168.8A6.35,6.35,0,0,0,24,177.18a6.41,6.41,0,0,0,8.54-2.92,6.49,6.49,0,0,0-11.77-5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.32,189.7a6.35,6.35,0,0,0,3.23,8.38,6.41,6.41,0,0,0,8.54-2.92,6.49,6.49,0,0,0-11.77-5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.09,211a6.49,6.49,0,1,0,8.53-2.91A6.35,6.35,0,0,0,27.09,211"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.81,230.21a6.49,6.49,0,1,0,8.53-2.91,6.35,6.35,0,0,0-8.53,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.47,249.35A6.49,6.49,0,1,0,53,246.44a6.35,6.35,0,0,0-8.53,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.73,267.16A6.35,6.35,0,0,0,60,275.54a6.41,6.41,0,0,0,8.54-2.92,6.49,6.49,0,0,0-11.77-5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.34,281.24a6.34,6.34,0,0,0,3.24,8.38,6.41,6.41,0,0,0,8.54-2.92,6.33,6.33,0,0,0-3.24-8.37,6.4,6.4,0,0,0-8.54,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.78,296.91A6.34,6.34,0,0,0,92,305.29a6.41,6.41,0,0,0,8.54-2.92A6.33,6.33,0,0,0,97.32,294a6.4,6.4,0,0,0-8.54,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107,307.69a6.35,6.35,0,0,0,3.23,8.38,6.41,6.41,0,0,0,8.54-2.92A6.49,6.49,0,0,0,107,307.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127,317.51a4.74,4.74,0,0,0,2.42,6.27,4.8,4.8,0,0,0,6.39-2.19,4.73,4.73,0,0,0-2.42-6.26,4.78,4.78,0,0,0-6.39,2.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.79,323.62a3.83,3.83,0,1,0,5-1.73,3.8,3.8,0,0,0-5,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.85,327.61a3.27,3.27,0,0,0,1.67,4.32,3.31,3.31,0,0,0,4.4-1.5,3.25,3.25,0,0,0-1.67-4.31,3.29,3.29,0,0,0-4.4,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.65,328.91a3.05,3.05,0,1,0,4-1.37,3,3,0,0,0-4,1.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.76,328.14a2.15,2.15,0,1,0,2.83-1,2.12,2.12,0,0,0-2.83,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.63,52.17a6.19,6.19,0,1,0,8.13-2.79,6.11,6.11,0,0,0-8.13,2.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.56,37.18a6.19,6.19,0,1,0,8.13-2.79,6.11,6.11,0,0,0-8.13,2.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.94,25.08a6,6,0,0,0,3.09,8,6,6,0,1,0-3.09-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138,8.29a5.29,5.29,0,0,0,9.6,4.45,5.15,5.15,0,0,0-2.64-6.82,5.21,5.21,0,0,0-7,2.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.42,3.75a4.4,4.4,0,0,0,8,3.7,4.4,4.4,0,0,0-8-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.52,2a3.73,3.73,0,0,0,6.77,3.14A3.65,3.65,0,0,0,187.43.36,3.69,3.69,0,0,0,182.52,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.89,3.17a3.22,3.22,0,0,0,1.65,4.27A3.26,3.26,0,0,0,209.89,6a3.23,3.23,0,0,0-1.65-4.27,3.27,3.27,0,0,0-4.35,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.22,6.82a3.22,3.22,0,0,0,1.65,4.27,3.26,3.26,0,0,0,4.35-1.49,3.22,3.22,0,0,0-1.65-4.27,3.26,3.26,0,0,0-4.35,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.54,13.52a2.8,2.8,0,1,0,3.67-1.25,2.74,2.74,0,0,0-3.67,1.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.73,15.09a5.29,5.29,0,0,0,9.6,4.45,5.3,5.3,0,0,0-9.6-4.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.91,91.83a5.37,5.37,0,1,0,6.82-3,5.3,5.3,0,0,0-6.82,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.05,107.51a5.64,5.64,0,1,0,7.15-3.16,5.51,5.51,0,0,0-7.15,3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.2,124.61a5.51,5.51,0,0,0,3.43,7,5.57,5.57,0,0,0,7.17-3.17,5.64,5.64,0,0,0-10.6-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.91,143.65a5.64,5.64,0,1,0,7.15-3.16,5.51,5.51,0,0,0-7.15,3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.24,161.42a5.64,5.64,0,1,0,7.16-3.16,5.51,5.51,0,0,0-7.16,3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43,179.79a5.51,5.51,0,0,0,3.43,7,5.57,5.57,0,0,0,7.17-3.17A5.64,5.64,0,0,0,43,179.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.42,197.92a5.64,5.64,0,1,0,7.15-3.16,5.51,5.51,0,0,0-7.15,3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.74,215.55a5.64,5.64,0,1,0,7.15-3.16,5.51,5.51,0,0,0-7.15,3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.31,232a5.64,5.64,0,1,0,7.15-3.16A5.51,5.51,0,0,0,59.31,232"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.34,248a5.64,5.64,0,1,0,7.15-3.16A5.51,5.51,0,0,0,69.34,248"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.12,262.63a5.51,5.51,0,0,0,3.43,7,5.57,5.57,0,0,0,7.17-3.17,5.64,5.64,0,0,0-10.6-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.86,274.05a5.64,5.64,0,1,0,7.15-3.16,5.51,5.51,0,0,0-7.15,3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.36,286.41a5.51,5.51,0,0,0,3.43,7,5.57,5.57,0,0,0,7.17-3.17,5.64,5.64,0,0,0-10.6-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.6,294.12a5.64,5.64,0,1,0,7.15-3.16,5.51,5.51,0,0,0-7.15,3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146,301.82a3.55,3.55,0,1,0,4.51-2,3.48,3.48,0,0,0-4.51,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.46,305.52a3.55,3.55,0,1,0,4.51-2,3.48,3.48,0,0,0-4.51,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.65,307.14a3.48,3.48,0,0,0,2.16,4.42,3.51,3.51,0,0,0,4.52-2,3.56,3.56,0,0,0-6.68-2.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200,306.55a3.55,3.55,0,1,0,4.51-2,3.48,3.48,0,0,0-4.51,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.25,303.65a3.12,3.12,0,1,0,4-1.75,3,3,0,0,0-4,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.39,75.86a5.37,5.37,0,1,0,6.82-3,5.25,5.25,0,0,0-6.82,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.2,62.17a5.37,5.37,0,1,0,6.82-3,5.25,5.25,0,0,0-6.82,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101,50.13a5.37,5.37,0,1,0,6.82-3,5.25,5.25,0,0,0-6.82,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.5,32.58a4.48,4.48,0,0,0,2.8,5.71,4.53,4.53,0,0,0,5.84-2.59,4.6,4.6,0,0,0-8.64-3.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.79,27.46a4.16,4.16,0,1,0,5.28-2.33,4.06,4.06,0,0,0-5.28,2.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.3,24.7a3.82,3.82,0,1,0,4.84-2.14,3.73,3.73,0,0,0-4.84,2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190,23.86a2.87,2.87,0,1,0,3.65-1.61A2.81,2.81,0,0,0,190,23.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.58,25.5a2.44,2.44,0,0,0,1.53,3.12,2.48,2.48,0,0,0,3.19-1.41,2.51,2.51,0,0,0-4.72-1.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M227,30.09a2.17,2.17,0,1,0,2.75-1.22A2.11,2.11,0,0,0,227,30.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.84,40.7a4.48,4.48,0,0,0,2.8,5.71,4.53,4.53,0,0,0,5.84-2.59,4.48,4.48,0,0,0-2.8-5.7,4.53,4.53,0,0,0-5.84,2.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.44,297.87a2.38,2.38,0,0,0,1.21,3.15,2.42,2.42,0,0,0,3.21-1.1,2.44,2.44,0,0,0-4.42-2.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258,288.7a2.2,2.2,0,0,0,1.13,2.92A2.18,2.18,0,1,0,258,288.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.15,278.44a1.93,1.93,0,0,0,1,2.56,2,2,0,0,0,2.61-.89,1.94,1.94,0,0,0-1-2.56,2,2,0,0,0-2.61.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.64 109.83 172.09 109.83 172.09 130.87 133.93 130.87 133.93 141.1 166.69 141.1 166.69 160.64 133.93 160.64 133.93 191.9 108.64 191.9 108.64 109.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "181.04 109.83 248.99 109.83 248.99 130.87 206.34 130.87 206.34 141.1 245.07 141.1 245.07 160.64 206.34 160.64 206.34 170.87 250.25 170.87 250.25 191.9 181.04 191.9 181.04 109.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262,109.83h41.5c27.36,0,37,20.23,37,40.92,0,25.18-13.34,41.15-42,41.15H262Zm25.29,61h9.89c15.75,0,18.05-12.76,18.05-20.46,0-5.17-1.61-19.54-19.89-19.54h-8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M374.15,109.83h24.72l29.89,82.08H402.55l-3.45-11.73H373l-3.68,11.73h-25.4ZM394,162.59l-7.36-25.29h-.23l-7.93,25.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.64 202.1 119.02 202.1 119.02 203.94 111.27 203.94 111.27 207.13 118.08 207.13 118.08 208.87 111.27 208.87 111.27 214.27 108.64 214.27 108.64 202.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "121.14 202.1 131.97 202.1 131.97 203.94 123.77 203.94 123.77 207.13 131.35 207.13 131.35 208.87 123.77 208.87 123.77 212.43 132.12 212.43 132.12 214.27 121.14 214.27 121.14 202.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.41,202.1h6.24c4.63,0,6.63,2.73,6.63,6.09s-2,6.09-6.63,6.09h-6.24ZM137,212.54h2.59c4.13,0,5-1.91,5-4.35s-.88-4.35-5-4.35H137Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "149.63 202.1 160.47 202.1 160.47 203.94 152.26 203.94 152.26 207.13 159.85 207.13 159.85 208.87 152.26 208.87 152.26 212.43 160.62 212.43 160.62 214.27 149.63 214.27 149.63 202.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.91,202.1h7.19c3.28,0,5,1.23,5,3.29a3.12,3.12,0,0,1-2.49,3.07v0a2.36,2.36,0,0,1,2.23,2.57c0,1.41.25,2.71.82,3.21h-2.82a2.84,2.84,0,0,1-.4-1.79c0-2.23-.57-3.22-3-3.22h-3.87v5h-2.63V202.1Zm2.63,5.54h4.32c1.66,0,2.57-.67,2.57-1.94,0-1.55-1.24-1.86-2.61-1.86h-4.28v3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.77,202.1h2.8l5.79,12.17h-2.83l-1.41-3.22h-6l-1.41,3.22H176Zm-.92,7.33h4.59l-2.25-5.23h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202,206c-.44-1.4-1.56-2.42-3.75-2.42a4.64,4.64,0,0,0,0,9.28,3.54,3.54,0,0,0,3.83-3.19h2.57c-.21,2.92-2.76,4.93-6.4,4.93-4.51,0-7.2-2.9-7.2-6.38s2.69-6.38,7.2-6.38c3.39,0,6.06,1.53,6.38,4.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 207.03,
    y: 202.1,
    width: 2.63,
    height: 12.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.5,208.19c0,3.48-2.7,6.38-7.2,6.38s-7.2-2.9-7.2-6.38,2.7-6.38,7.2-6.38,7.2,2.9,7.2,6.38m-11.77,0a4.57,4.57,0,1,0,4.57-4.64,4.32,4.32,0,0,0-4.57,4.64m4.88-9.48h2.84l-3,2.44h-1.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "228.81 202.1 231.59 202.1 238.46 211.07 238.5 211.07 238.5 202.1 241 202.1 241 214.27 238.22 214.27 231.38 205.32 231.31 205.32 231.31 214.27 228.81 214.27 228.81 202.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "250 202.1 260.82 202.1 260.82 203.94 252.63 203.94 252.63 207.13 260.21 207.13 260.21 208.87 252.63 208.87 252.63 212.43 260.98 212.43 260.98 214.27 250 214.27 250 202.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M273.42,206c-.44-1.4-1.56-2.42-3.75-2.42a4.64,4.64,0,0,0,0,9.28,3.54,3.54,0,0,0,3.83-3.19h2.57c-.21,2.92-2.76,4.93-6.4,4.93-4.51,0-7.2-2.9-7.2-6.38s2.69-6.38,7.2-6.38c3.39,0,6.06,1.53,6.38,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.32,202.1H281v7.09c0,1.64.13,3.53,3.54,3.53s3.54-1.89,3.54-3.53V202.1h2.63v7.79c0,3.12-2.46,4.67-6.17,4.67s-6.17-1.55-6.17-4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.73,202.1h2.8l5.79,12.17h-2.83l-1.41-3.22h-6l-1.41,3.22H292Zm-.92,7.33h4.59l-2.25-5.23h-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "304.4 202.1 316.58 202.1 316.58 203.94 311.8 203.94 311.8 214.27 309.17 214.27 309.17 203.94 304.4 203.94 304.4 202.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M331.94,208.19c0,3.48-2.69,6.38-7.2,6.38s-7.2-2.9-7.2-6.38,2.69-6.38,7.2-6.38,7.2,2.9,7.2,6.38m-11.77,0a4.57,4.57,0,1,0,4.57-4.64,4.32,4.32,0,0,0-4.57,4.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M334.35,202.1h7.18c3.28,0,5,1.23,5,3.29a3.12,3.12,0,0,1-2.49,3.07v0a2.36,2.36,0,0,1,2.23,2.57c0,1.41.26,2.71.82,3.21h-2.82a2.84,2.84,0,0,1-.4-1.79c0-2.23-.57-3.22-3-3.22H337v5h-2.63V202.1Zm2.63,5.54h4.32c1.66,0,2.57-.67,2.57-1.94,0-1.55-1.24-1.86-2.61-1.86H337v3.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 349.19,
    y: 202.1,
    width: 2.63,
    height: 12.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M359.08,202.1h2.8l5.79,12.17h-2.83l-1.41-3.22h-6L356,214.27H353.3Zm-.93,7.33h4.59l-2.25-5.23h-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "369.01 202.1 371.8 202.1 378.67 211.07 378.7 211.07 378.7 202.1 381.21 202.1 381.21 214.27 378.43 214.27 371.58 205.32 371.51 205.32 371.51 214.27 369.01 214.27 369.01 202.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M388.36,202.1h2.8L397,214.27h-2.83l-1.41-3.22h-6l-1.41,3.22h-2.72Zm-.93,7.33H392l-2.25-5.23h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M404.25,202.1h6.24c4.63,0,6.63,2.73,6.63,6.09s-2,6.09-6.63,6.09h-6.24Zm2.64,10.44h2.59c4.13,0,5-1.91,5-4.35s-.88-4.35-5-4.35h-2.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "419.48 202.1 430.31 202.1 430.31 203.94 422.12 203.94 422.12 207.13 429.69 207.13 429.69 208.87 422.12 208.87 422.12 212.43 430.45 212.43 430.45 214.27 419.48 214.27 419.48 202.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.23,222.05h5.38l7.6,15.48h-5.52l-1.25-2.78h-7.09l-1.28,2.78h-5.43Zm.34,9.71h4.61l-2.25-5.42h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.52,237.53h-3.41l-.31-1.69a8,8,0,0,1-5.67,2c-6.15,0-10.13-3.58-10.13-8.07s4-8.07,10.13-8.07c4.21,0,8.71,1.71,9.19,5.59H144c-.17-1.32-1.88-2.12-4-2.12a4.6,4.6,0,1,0,0,9.2c2.62,0,4.38-.93,4.67-2.34H141v-3h8.54v8.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.93 222.04 169.13 222.04 169.13 225.28 158.22 225.28 158.22 227.99 168.19 227.99 168.19 231.11 158.22 231.11 158.22 234.06 169.41 234.06 169.41 237.53 152.93 237.53 152.93 222.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "172.38 222.04 177.81 222.04 184.88 231.59 184.94 231.59 184.94 222.04 189.91 222.04 189.91 237.53 184.47 237.53 177.41 227.88 177.37 227.88 177.37 237.53 172.38 237.53 172.38 222.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "209.66 225.51 203.59 225.51 203.59 237.53 198.29 237.53 198.29 225.51 192.24 225.51 192.24 222.04 209.66 222.04 209.66 225.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "212 222.04 228.21 222.04 228.21 225.28 217.31 225.28 217.31 227.99 227.26 227.99 227.26 231.11 217.31 231.11 217.31 234.06 228.5 234.06 228.5 237.53 212 237.53 212 222.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.64,232.32c.11,1.82,1.59,2.41,3.84,2.41,1.6,0,3.25-.43,3.25-1.58,0-1.36-2.9-1.63-5.84-2.25s-5.95-1.63-5.95-4.47c0-3.38,4.47-4.7,8.28-4.7,4,0,8.11,1.49,8.14,5h-5.3c.09-1.41-1.65-1.87-3.27-1.87-1.14,0-2.56.3-2.56,1.32,0,1.19,2.93,1.41,5.89,2s5.89,1.67,5.89,4.47c0,3.93-4.38,5.18-8.85,5.18-4.67,0-8.8-1.56-8.82-5.53h5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M259.49,222h8.74c6.23,0,10,2.88,10,7.68,0,5.07-3.79,7.81-10,7.81h-8.74Zm5.29,12h2.51c4-.06,5.61-1.26,5.61-4.36,0-2.82-2-4.18-5.61-4.18h-2.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "281.12 222.04 297.31 222.04 297.31 225.28 286.4 225.28 286.4 227.99 296.37 227.99 296.37 231.11 286.4 231.11 286.4 234.06 297.6 234.06 297.6 237.53 281.12 237.53 281.12 222.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M315.12,222.05h5.38l7.6,15.48h-5.52l-1.25-2.78h-7.09L313,237.53h-5.43Zm.34,9.71h4.61l-2.25-5.42h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M329.65,222h8.74c6.23,0,10,2.88,10,7.68,0,5.07-3.79,7.81-10,7.81h-8.74Zm5.29,12h2.51c4-.06,5.61-1.26,5.61-4.36,0-2.82-2-4.18-5.61-4.18h-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.83,231.13c0,4.49-2.7,6.72-8.85,6.72s-8.85-2.23-8.85-6.72V222h5.29v9.32c0,2,1,3,3.56,3s3.56-1,3.56-3V222h5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377.9,222.05h5.38l7.6,15.48h-5.52l-1.25-2.78H377l-1.28,2.78h-5.43Zm.34,9.71h4.61l-2.25-5.42h-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "392.38 222.04 397.81 222.04 404.88 231.59 404.94 231.59 404.94 222.04 409.92 222.04 409.92 237.53 404.48 237.53 397.43 227.88 397.37 227.88 397.37 237.53 392.38 237.53 392.38 222.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M419.06,222.05h5.38l7.6,15.48h-5.52l-1.25-2.78h-7.09l-1.28,2.78h-5.43Zm.34,9.71H424l-2.25-5.42h-.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.085878cb98a2f6f279dcf6ff79d2267a.svg";
export { ForwardRef as ReactComponent };